export * from './room-item.component';